import { integerToMoney } from '../lib/moneyHandler'

export function useMoneyFormatter() {
  const CURRENCY_REGEX = /^[A-Z]{3}$/i

  function formatCurrencyValue(
    value: string,
    currency: string,
    formatOptions: Intl.NumberFormatOptions = {}
  ) {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: CURRENCY_REGEX.test(currency) ? currency : 'EUR',
      maximumFractionDigits: +value % 100 ? 2 : 0,
      ...formatOptions,
    }).format(integerToMoney(+value))
  }

  function formatCurrencyValueToParts(
    value: string,
    currency: string,
    formatOptions = {}
  ) {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: CURRENCY_REGEX.test(currency) ? currency : 'EUR',
      maximumFractionDigits: +value % 100 ? 2 : 0,
      ...formatOptions,
    }).formatToParts(integerToMoney(+value))
  }

  return {
    formatCurrencyValue,
    formatCurrencyValueToParts,
  }
}
